"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconUserAltActive = Experimental__IconUserAltActive;
exports.IconUserAltActive = IconUserAltActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconUserAltActive is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconUserAltActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M.422 16v-.672a4 4 0 0 1 2-3.464l3.112-1.797a1.2 1.2 0 0 0 .322-1.808l-.487-.584c-.758-.904-1.28-1.94-1.353-3.177-.041-.696.08-1.418.2-1.775a3.97 3.97 0 0 1 .824-1.421 4.015 4.015 0 0 1 5.92 0c.376.41.644.894.823 1.421.121.357.242 1.08.2 1.775-.073 1.238-.594 2.273-1.352 3.177l-.487.584a1.2 1.2 0 0 0 .322 1.808l3.112 1.797a4 4 0 0 1 2 3.464V16H.422z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M2.054 22v-1.604a4 4 0 0 1 2-3.464l4.787-2.764a1.5 1.5 0 0 0 .402-2.26l-.696-.834c-.995-1.187-1.68-2.546-1.776-4.17-.054-.913.105-1.861.264-2.33a5.21 5.21 0 0 1 1.08-1.865 5.27 5.27 0 0 1 7.77 0 5.21 5.21 0 0 1 1.08 1.865c.16.469.318 1.417.264 2.33-.097 1.624-.781 2.983-1.776 4.17l-.696.835a1.5 1.5 0 0 0 .402 2.26l4.787 2.763a4 4 0 0 1 2 3.464V22H2.054z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconUserAltActive is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconUserAltActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconUserAltActive, props);
}